import { render, staticRenderFns } from "./TopThematicsOverPeriod.vue?vue&type=template&id=01ae5d28&"
import script from "./TopThematicsOverPeriod.vue?vue&type=script&lang=js&"
export * from "./TopThematicsOverPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports